import React from 'react';
import { Link } from 'react-router-dom';

function ProfileMobileStickyNav({ sections, activeSection }) {
  return (
    <div className="sticky top-16 z-20 -mx-4 border-y px-4 py-2 lg:hidden" style={{ backgroundColor: 'var(--surface)', borderColor: 'var(--border)' }}>
      <div className="no-scrollbar flex gap-2 overflow-x-auto pb-1" role="tablist" aria-label="Profile sections">
        {sections.map((section) => {
          const isActive = section.id === activeSection;
          return (
            <Link
              key={section.id}
              to={`/profile/${section.id}`}
              className="whitespace-nowrap rounded-full border px-3 py-1.5 text-xs font-medium transition-colors"
              style={{
                borderColor: isActive
                  ? 'color-mix(in srgb, var(--primary) 45%, var(--border))'
                  : 'var(--border)',
                backgroundColor: isActive
                  ? 'color-mix(in srgb, var(--primary) 10%, var(--surface))'
                  : 'transparent',
                color: isActive ? 'var(--primary)' : 'var(--page-heading-color)',
              }}
            >
              {section.label}
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default ProfileMobileStickyNav;
